import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { apiPost, operationsClient } from '@/lib/api';
import { leadEndpoints } from '@/lib/api/endpoints';
import { leadKeys } from '@/lib/queryKeys';
import { useApiMutation } from '../useApiMutation';
import type { LeadActivity } from '@/types/lead';

export interface CreateLeadActivityDto {
  type:
    | 'CALL_OUTBOUND'
    | 'CALL_INBOUND'
    | 'SMS_SENT'
    | 'SMS_RECEIVED'
    | 'EMAIL_SENT'
    | 'EMAIL_RECEIVED'
    | 'NOTE'
    | 'STAGE_CHANGE'
    | 'VOICEMAIL'
    | 'FORM_SUBMISSION'
    | 'CHAT';
  content?: string;
  durationSeconds?: number;
  callOutcome?: 'CONNECTED' | 'NO_ANSWER' | 'VOICEMAIL' | 'BUSY' | 'WRONG_NUMBER';
  timestamp?: string;
}

export function useCreateLeadActivity() {
  const queryClient = useQueryClient();

  return useApiMutation<LeadActivity, { leadId: string } & CreateLeadActivityDto>({
    mutationFn: ({ leadId, ...dto }) =>
      apiPost<LeadActivity, CreateLeadActivityDto>(
        operationsClient,
        leadEndpoints.activities(leadId),
        dto,
      ),
    onSuccess: (_data, { leadId }) => {
      void queryClient.invalidateQueries({ queryKey: [...leadKeys.detail(leadId), 'activity'] });
      void queryClient.invalidateQueries({ queryKey: leadKeys.detail(leadId) });
      void queryClient.invalidateQueries({ queryKey: leadKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: leadKeys.pipeline() });
      toast.success('Activity added');
    },
  });
}
